<template>
  <div class="paymentInfo">
    <QS-h4-title title="支付信息"/>
    <!-- eslint-disable-next-line vue/no-unused-refs -->
    <el-form ref='paymentInfo' :rules='paymentInfo_rules' :model='paymentInfo_obj'>
      <QS-column-box>
        <template>
          <el-form-item
          prop='carTotalAmount'
          :label="'合同总金额' + columnSeparator"
        >
          <el-input
            v-model="paymentInfo_obj.carTotalAmount"
            v-deleteEmoji="true"
            v-limit-money="true"
          >
          </el-input>
          </el-form-item>
          <el-form-item
            prop='deposit'
            :label="'总押金' + columnSeparator"
          >
          <el-input
            v-model="paymentInfo_obj.deposit"
            v-deleteEmoji="true"
            v-limit-money="true"
          >
          </el-input>
          </el-form-item>
          <el-form-item
            prop='manageFee'
            :label="'一次性管理费' + columnSeparator"
          >
          <el-input
            v-model="paymentInfo_obj.manageFee"
            v-deleteEmoji="true"
            v-limit-money="true"
          >
          </el-input>
          </el-form-item>
          <el-form-item
            prop='serviceFee'
            :label="'其他服务费' + columnSeparator"
          >
            <el-input
              v-model="paymentInfo_obj.serviceFee"
              v-deleteEmoji="true"
              v-limit-money="true"
            >
            </el-input>
          </el-form-item>
          <el-form-item
            prop='remarks'
            :label="'备注' + columnSeparator"
          >
            <el-input
              type="textarea"
              placeholder="请输入内容"
              maxlength="500"
              show-word-limit
              v-model='paymentInfo_obj.remarks'
            >
            </el-input>
          </el-form-item>
        </template>
      </QS-column-box>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      paymentInfo_obj: {
        carTotalAmount: '', // 合同总金额
        deposit: '', // 总押金
        serviceFee: '', // 其他服务费
        manageFee: '', // 一次性管理费
        remarks: '', // 备注
      },
      paymentInfo_rules: {},
    }
  },
}
</script>

<style lang="scss" scoped>
</style>
